<template>
  <zen-one 
  :showuserinfo="false" 
  title="iBAYAQ"
  :crumbs="crumbs"
  >
    <z-page
    title="Pengurusan iBayaq  - Laman Utama"
    >
        <div class="card-body card-scroll">
            <div class="row">

                <div class="card">
                    <div class="w-flex table-bar-search-title">
                        <h1>Laman Utama</h1>
                    </div>
                    <div class="card-body">
                        <div class="form-group col-md-12">
                            <div class="input-group">
                                <ckeditor :editor="editor" v-model="form.mainpage_content" :config="editorConfig"></ckeditor>
                            </div>
                        </div>
                        <div class="w-card table-bar-search-bottom text-right" style="padding-top:5px;padding-bottom:5px;">
                            <button class="w-button w-button--dark size--md indigo-dark2--bg ml1 indigo-dark2--bg ml1" type="button" @click="saveMainPage()">Simpan</button>
                        </div>
                        
                    </div>
                </div>
                <br>
                <br>
                <br>
                <!-- <div class="card">
                    <div class="w-flex table-bar-search-title">
                        <h1>Pengumuman</h1>
                        <div class="spacer"></div>
                        <div class="w-button w-button--dark size--md indigo-dark2--bg ml1 indigo-dark2--bg ml1" v-on:click="addPengumuman"><i class="mdi mdi-message-plus"></i> Tambah</div>
                    </div>
                    <div class="card-body">
                        <div v-for="umum, idx in form_pengumuman.pengumumans" class="form-group col-md-12 newline" style="background:#f1f5fb;">
                            <div class="input-group pegumuman">
                                <ckeditor :editor="editor" v-model="form_pengumuman.pengumumans[idx]" :config="editorConfig"></ckeditor>
                                <button class="w-button w-button--light hapus" @click="removePengumuman(idx)">Hapus</button>
                            </div>
                        </div>
                        <div class="w-card table-bar-search-bottom text-right" style="padding-top:5px;padding-bottom:5px;">
                            <button class="w-button w-button--dark size--md indigo-dark2--bg ml1 indigo-dark2--bg ml1" type="button" @click="savePengumuman()">Simpan</button>
                        </div>
                    </div>
                </div> -->

            </div>
        </div>
        
    </z-page>
  </zen-one>
</template>

<script>
import ZResource from "@/Modules/z-resource-service"
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  extends: ZResource,
  props: {
    // mainpage: [Array, Object],
    // umum_contents: [Array, Object],
  },
  data() {
    return {
            resourceurl: this.service_ibayaq + "cms/laman_utama",
            editor: ClassicEditor,
            form: {
                mainpage_content: '',
            },
            form_pengumuman: {
                pengumumans: [],
            },
            editorConfig: {
                width: '500px'
            },
            resourceurl: 'admin.permission',
            reload: true,
            crumbs: [
                { label: this.$page.props.app_name, route: '/sitemap' },
                // { label: 'Utama', route: '/' },
                { label: 'Pengurusan Ibayaq', route: '/ibayaq/laman_utama' },
                { label: 'Laman Utama', route: '/ibayaq/laman_utama' }
            ],
    }
  },
  methods: {
        getData() {
            this.$zcomm
                .get(this.service_ibayaq + "cms/laman_utama")
                .then((res) => {
                    this.form.mainpage_content = res.mainpage.content;
                    this.form_pengumuman.pengumumans = res.umum_contents;
                })
                .catch((err) => {})
                .finally(() => {});
        },
        saveMainPage(){
            this.$zcomm.post(this.service_ibayaq + "cms/laman_utama/savemainpage", this.form)
            .then(alert("Rekod Telah Berjaya Disimpan"));
            // location.reload();
        },
        savePengumuman(){
            this.$zcomm.post(this.service_ibayaq + "cms/laman_utama/savepengumuman", this.form_pengumuman)
            .then(alert("Rekod Telah Berjaya Disimpan"));
            // location.reload();
        },
        addPengumuman(){
            this.form_pengumuman.pengumumans.push("")
            this.$forceUpdate()
        },
        removePengumuman(idx){
            this.form_pengumuman.pengumumans.splice(idx,1)
            this.$forceUpdate()
        },
  },
  watch: {
    
  },
  mounted() {
    this.getData();
    //    console.log(Ziggy.routes);
  },
}
</script>
<style>
    .hapus {
        margin-top: 5px;
        margin-bottom: 5px;
        margin-left: 94%;
    }
</style>